import { SelectOption } from 'dcloud-shared-ui';

export const convertScriptsToOptions = (
  scripts: HardwareScript[],
): SelectOption<string>[] =>
  scripts.map((item) => ({ name: item.name, value: item.uid }));
